module.exports = __webpack_public_path__ + "img/bg-servicios-3.eb20fd6b.png";